module.exports = __webpack_public_path__ + "static/media/setting.b239d42c.svg";